import { useLocation } from "react-router-dom";

import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { getModuleByPath } from "@/portals/admin/dashboard/dashboardModules";
import { CLIENT_NAV } from "@/portals/client/nav";
import { DESIGNER_NAV } from "@/portals/designer/nav";

/**
 * Resolve a human page name from the current path for the document title.
 */
// eslint-disable-next-line react-refresh/only-export-components -- Helper function co-located with component
export function resolvePageTitle(pathname: string): string | null {
  if (pathname === "/" || pathname === "") return "Home";

  if (
    pathname.startsWith("/signin") ||
    pathname.startsWith("/login") ||
    pathname.startsWith("/auth")
  ) {
    if (pathname.includes("check-email")) return "Check Email";
    if (pathname.includes("reset-password")) return "Reset Password";
    return "Sign In";
  }

  if (pathname === "/intern-signup") return "Intern Signup";

  if (
    pathname === "/design-requests/create" ||
    pathname === "/client/design-requests/create"
  ) {
    return "New Design Request";
  }

  if (pathname === "/client/login") return "Client Sign In";
  if (pathname === "/client/signup") return "Client Sign Up";
  if (pathname === "/client/profile") return "Profile";

  const clientItem =
    CLIENT_NAV.find((item) => item.path === pathname) ??
    CLIENT_NAV.find((item) => pathname.startsWith(`${item.path}/`));
  if (clientItem) return clientItem.label;

  const designerItem =
    DESIGNER_NAV.find((item) => item.path === pathname) ??
    DESIGNER_NAV.find((item) => pathname.startsWith(`${item.path}/`));
  if (designerItem) return designerItem.label;

  if (pathname === "/designer" || pathname.startsWith("/designer/")) {
    return "Designer";
  }

  const module = getModuleByPath(pathname);
  if (module) return module.label;

  return null;
}

/** Keeps `document.title` in sync with the active route. */
export function DocumentTitle() {
  const { pathname } = useLocation();
  useDocumentTitle(resolvePageTitle(pathname));
  return null;
}
